module.exports = __webpack_public_path__ + "img/dsu.a9e7a82d.jpeg";